import {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

import "./ComicVideo.css";

import { UserAuthContext } from "../../Contexts/UserAuthContext";
import SampleVideoModal from "../../Components/VideoAi/SampleVideoModal";
import SampleTextVideo from "../../Components/AIVideoSample/TextVideo";
import AiContentAudit from "../../Components/AiContentAudit/AiContentAudit";

import reload from "../../Assets/Images/relaoder.png";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";

const API_BASE_URL = "https://backend.whalesai.com/api/v1";

const PROMPT_CHECKER_URL = `${API_BASE_URL}/prompt-checker/check`;
const GENERATE_VIDEO_URL = `${API_BASE_URL}/comic-video-ai/generate`;

const MAX_SCRIPT_WORDS = 600;
const BASE_CREDITS = 500;
const AUDIT_EXTRA_CREDITS = 334;

const aspectRatioOptions = [
  {
    value: "1:1",
    label: "1:1",
    description: "Square poster",
  },
  {
    value: "9:16",
    label: "9:16",
    description: "Mobile / Story / TikTok",
  },
  {
    value: "16:9",
    label: "16:9",
    description: "Wide cinematic poster",
  },
];

const exampleQuestions = [
  "The Birth of the Solar System",
  "How Dinosaurs Ruled the Earth",
  "The Wonders of the Human Brain",
  "How the Internet Works",
  "The History of Space Exploration",
  "Understanding Climate Change",
  "The Mysteries of the Ocean",
  "How Planes Stay in the Air",
  "The Evolution of Life on Earth",
  "How Volcanoes Erupt",
  "The Science of Earthquakes",
  "The Life Cycle of a Star",
  "The Secrets of DNA",
  "The History of Ancient Egypt",
  "The Human Digestive System Explained",
  "How Batteries Store Energy",
  "The Journey of a Raindrop",
  "The Physics of Roller Coasters",
  "The World of Microbes",
  "The History of the Roman Empire",
  "The Function of the Human Heart",
  "The Science Behind Vaccines",
  "The Basics of Quantum Physics",
  "How Plants Perform Photosynthesis",
  "The History of the Olympic Games",
  "How Electricity Powers Our World",
  "The Science of Cooking",
  "The Story of the Great Wall of China",
  "How Computers Work",
  "The Wonders of the Animal Kingdom",
  "The History of the Renaissance",
  "How Telescopes Work",
  "The Life of a Honeybee",
  "The Basics of the Human Immune System",
  "The Science Behind Weather Forecasting",
  "The Story of the Titanic",
  "The Evolution of Human Languages",
  "How the Moon Affects Earth",
  "The Life Cycle of a Butterfly",
  "The Science of Sound Waves",
  "The History of the Printing Press",
  "How Bridges Are Built",
  "The Secrets of Coral Reefs",
  "The History of the Space Race",
  "The Basics of Human Genetics",
  "The Science of Optical Illusions",
  "The History of the Internet",
  "How Engines Work",
  "The Wonders of the Night Sky",
  "The History of Ancient Greece",
  "The Human Respiratory System Explained",
  "The Science of Renewable Energy",
  "The Story of the Pyramids",
  "How Robots Work",
  "The Basics of Chemical Reactions",
  "The History of the French Revolution",
  "The World of Insects",
  "The Evolution of Technology",
  "How Submarines Work",
  "The History of Medieval Europe",
  "The Science of Sleep",
  "The Wonders of the Amazon Rainforest",
  "How Magnets Work",
  "The History of the Industrial Revolution",
  "The Science of Climate Zones",
  "The Evolution of the Human Species",
  "How Satellites Work",
  "The History of the Cold War",
  "The Human Circulatory System Explained",
  "The Science of Germs and Hygiene",
  "The History of Ancient Mesopotamia",
  "How Skyscrapers Are Built",
  "The Basics of Ecosystems",
  "The Story of the Wright Brothers",
  "How Solar Panels Work",
  "The Science of Black Holes",
  "The History of the Viking Age",
  "The Human Skeletal System Explained",
  "The Science of Natural Disasters",
  "The History of the Space Shuttle",
  "How Rockets Work",
  "The Wonders of the Desert Biome",
  "The Basics of Photosynthesis",
  "The History of the British Empire",
  "The Science Behind the Human Voice",
  "The Evolution of Music",
  "How Wind Turbines Work",
  "The History of the American Revolution",
  "The Human Nervous System Explained",
  "The Science of Bacteria",
  "The History of the World Wars",
  "How 3D Printing Works",
  "The Wonders of the Arctic Circle",
  "The Basics of Animal Behavior",
  "The Story of the Moon Landing",
  "The Science Behind Holograms",
  "The History of Ancient Rome",
  "How Electric Cars Work",
];

const getRandomQuestion = (currentQuestion = "") => {
  const availableQuestions = exampleQuestions.filter(
    (question) => question !== currentQuestion
  );

  const questions =
    availableQuestions.length > 0
      ? availableQuestions
      : exampleQuestions;

  return questions[Math.floor(Math.random() * questions.length)];
};

const countWords = (value = "") => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return 0;
  }

  return trimmedValue.split(/\s+/).length;
};

const getErrorMessage = (error, fallbackMessage) => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallbackMessage
  );
};

const ComicVideo = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { AIuser, userRefetch, setUserRefetch, isBack } =
    useContext(UserAuthContext);

  const [randomQuestion, setRandomQuestion] = useState(() =>
    getRandomQuestion()
  );

  const [modalShow, setModalShow] = useState(false);
  const [videoModal, setVideoModal] = useState(false);

  const [attributionPage, setAttributionPage] = useState(true);
  const [aspectRatio, setAspectRatio] = useState("");

  const [inputText, setInputText] = useState("");
  const [enableOwnScript, setEnableOwnScript] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [checkingPrompt, setCheckingPrompt] = useState(false);
  const [suggestedIdea, setSuggestedIdea] = useState("");
  const [promptError, setPromptError] = useState("");

  const [auditChecked, setAuditChecked] = useState(false);

  const promptTimeoutRef = useRef(null);
  const promptRequestIdRef = useRef(0);
  const mountedRef = useRef(true);
  const generatingRef = useRef(false);

  const wordCount = countWords(inputText);
  const exceedsWordLimit =
    enableOwnScript && wordCount > MAX_SCRIPT_WORDS;

  const credit = auditChecked
    ? BASE_CREDITS + AUDIT_EXTRA_CREDITS
    : BASE_CREDITS;

  const creditCostUSD = auditChecked ? 10.01 : 6;

  const userCredits = Number(AIuser?.credits ?? 0);
  const creditToLocalString = Math.floor(
    Math.max(0, userCredits)
  ).toLocaleString();

  const hasInput = Boolean(inputText.trim());
  const hasValidAspectRatio = aspectRatioOptions.some(
    (option) => option.value === aspectRatio
  );

  const isGenerateButtonDisabled =
    !hasInput ||
    !hasValidAspectRatio ||
    isLoading ||
    exceedsWordLimit;

  const clearPromptTimeout = useCallback(() => {
    if (promptTimeoutRef.current) {
      clearTimeout(promptTimeoutRef.current);
      promptTimeoutRef.current = null;
    }
  }, []);

  /*
   * Cleanup timers and invalidate pending prompt requests
   * when the component unmounts.
   */
  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;

      if (promptTimeoutRef.current) {
        clearTimeout(promptTimeoutRef.current);
      }

      promptRequestIdRef.current += 1;
    };
  }, []);

  /*
   * Restore the text when navigating back from another page.
   * Avoid overwriting valid text with undefined.
   */
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });

    const state = location.state;

    if (state?.back && isBack && typeof state.inputText === "string") {
      setInputText(state.inputText);
      return;
    }

    if (typeof state?.requestQues === "string") {
      setInputText(state.requestQues);
    }
  }, [location.key, location.state, isBack]);

  /*
   * Prompt suggestion API.
   *
   * A request ID prevents an older API response from
   * replacing a suggestion for a newer prompt.
   */
  const checkComicIdeaPrompt = useCallback(
    async (value) => {
      const prompt = value.trim();
      const requestId = ++promptRequestIdRef.current;

      if (!prompt || enableOwnScript) {
        setSuggestedIdea("");
        setPromptError("");
        setCheckingPrompt(false);
        return;
      }

      const authToken = localStorage.getItem("aiUser");

      if (!authToken) {
        setSuggestedIdea("");
        setCheckingPrompt(false);
        setPromptError("Please log in again to generate suggestions.");
        return;
      }

      setCheckingPrompt(true);
      setSuggestedIdea("");
      setPromptError("");

      try {
        const response = await axios.post(
          PROMPT_CHECKER_URL,
          {
            prompt,
            aiService: "comic-video-ai",
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
            timeout: 60000,
          }
        );

        /*
         * Ignore stale responses.
         */
        if (
          !mountedRef.current ||
          requestId !== promptRequestIdRef.current
        ) {
          return;
        }

        const responseData = response?.data;

        const suggestion =
          responseData?.data?.suggested_prompt ||
          responseData?.data?.suggestedPrompt ||
          responseData?.data?.suggestion ||
          responseData?.suggested_prompt ||
          responseData?.suggestedPrompt ||
          responseData?.suggestion ||
          "";

        if (
          responseData?.success === false ||
          responseData?.success === 0
        ) {
          setSuggestedIdea("");
          setPromptError(
            responseData?.message ||
              "Could not generate a suggestion. Please try again."
          );
          return;
        }

        if (typeof suggestion === "string" && suggestion.trim()) {
          setSuggestedIdea(suggestion.trim());
          setPromptError("");
        } else {
          setSuggestedIdea("");
          setPromptError(
            responseData?.message ||
              "No suggestion was returned. Try a different title."
          );
        }
      } catch (error) {
        if (
          !mountedRef.current ||
          requestId !== promptRequestIdRef.current
        ) {
          return;
        }

        console.error("Comic Video prompt checker error:", error);

        setSuggestedIdea("");
        setPromptError(
          getErrorMessage(
            error,
            "Unable to generate a suggestion. Please try again."
          )
        );
      } finally {
        if (
          mountedRef.current &&
          requestId === promptRequestIdRef.current
        ) {
          setCheckingPrompt(false);
        }
      }
    },
    [enableOwnScript]
  );

  /*
   * Debounce suggestion requests while the user is typing.
   */
  const schedulePromptCheck = useCallback(
    (value) => {
      clearPromptTimeout();

      promptRequestIdRef.current += 1;
      setCheckingPrompt(false);
      setPromptError("");
      setSuggestedIdea("");

      if (!value.trim() || enableOwnScript) {
        return;
      }

      promptTimeoutRef.current = setTimeout(() => {
        promptTimeoutRef.current = null;
        checkComicIdeaPrompt(value);
      }, 1000);
    },
    [checkComicIdeaPrompt, clearPromptTimeout, enableOwnScript]
  );

  const handleTextChange = (event) => {
    const text = event.target.value;

    setInputText(text);
    schedulePromptCheck(text);
  };

  /*
   * Selecting an example fills the input and requests
   * a suggestion for that example.
   */
  const handleExampleSelect = (question) => {
    setInputText(question);
    schedulePromptCheck(question);
  };

  const handleRandomQuestion = () => {
    setRandomQuestion((currentQuestion) =>
      getRandomQuestion(currentQuestion)
    );
  };

  /*
   * Toggle between a regular title and an own-script input.
   * Suggestions are only requested for title mode.
   */
  const handleOwnScriptChange = (event) => {
    const checked = event.target.checked;

    clearPromptTimeout();
    promptRequestIdRef.current += 1;

    setEnableOwnScript(checked);
    setSuggestedIdea("");
    setPromptError("");
    setCheckingPrompt(false);

    if (checked) {
      setInputText("");
    }
  };

  /*
   * Apply a suggested title to the input.
   */
  const handleSuggestionSelect = () => {
    if (!suggestedIdea) {
      return;
    }

    const selectedIdea = suggestedIdea;

    clearPromptTimeout();
    promptRequestIdRef.current += 1;

    setInputText(selectedIdea);
    setSuggestedIdea("");
    setPromptError("");
    setCheckingPrompt(false);
    setEnableOwnScript(false);

    /*
     * The selected suggestion becomes the current title.
     * Don't immediately call the same API again.
     */
  };

  /*
   * Clear all form values and pending suggestion work.
   */
  const handleClear = () => {
    clearPromptTimeout();
    promptRequestIdRef.current += 1;

    setInputText("");
    setAspectRatio("");
    setEnableOwnScript(false);
    setAttributionPage(true);
    setAuditChecked(false);

    setSuggestedIdea("");
    setPromptError("");
    setCheckingPrompt(false);
  };

  /*
   * Generate the comic video.
   */
  const ConfirmVideo = async () => {
    if (generatingRef.current || isGenerateButtonDisabled) {
      return;
    }

    const title = inputText.trim();

    if (!title) {
      await swal({
        title: "Title required",
        text: "Please enter a title or script before generating your video.",
        icon: "warning",
        className: "modal_class_success",
      });

      return;
    }

    if (!hasValidAspectRatio) {
      await swal({
        title: "Select an aspect ratio",
        text: "Please select an aspect ratio for your video.",
        icon: "warning",
        className: "modal_class_success",
      });

      return;
    }

    if (enableOwnScript && countWords(title) > MAX_SCRIPT_WORDS) {
      await swal({
        title: "Script is too long",
        text: `Your script must contain no more than ${MAX_SCRIPT_WORDS} words.`,
        icon: "warning",
        className: "modal_class_success",
      });

      return;
    }

    const authToken = localStorage.getItem("aiUser");

    if (!authToken) {
      await swal({
        title: "Login required",
        text: "Please log in again to generate a video.",
        icon: "warning",
        className: "modal_class_success",
      });

      return;
    }

    if (!AIuser) {
      await swal({
        title: "Account information unavailable",
        text: "Please refresh your account information and try again.",
        icon: "warning",
        className: "modal_class_success",
      });

      return;
    }

    /*
     * Equal credits are sufficient. The old comparison used
     * ">" and incorrectly rejected users with exactly enough.
     */
    if (userCredits < credit) {
      const shouldBuyCredits = await swal({
        title: "Insufficient credits",
        text: `You need ${credit.toLocaleString()} credits for this video. Your current balance is ${creditToLocalString}.`,
        icon: "error",
        buttons: {
          cancel: {
            text: "Cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Buy Credits",
            value: true,
          },
        },
        className: "modal_class_success",
      });

      if (shouldBuyCredits) {
        navigate("/purchase");
      }

      return;
    }

    generatingRef.current = true;
    setIsLoading(true);

    clearPromptTimeout();
    promptRequestIdRef.current += 1;

    const bodyContent = {
      title,
      email: AIuser.email,
      aspectRatio,
      attributionPage,
      credit,
      audit: auditChecked,
    };

    try {
      const response = await axios.post(
        GENERATE_VIDEO_URL,
        bodyContent,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
          timeout: 120000,
        }
      );

      const responseData = response?.data;

      /*
       * Support the existing backend success message,
       * while also accepting a conventional success flag.
       */
      const isSuccessful =
        responseData?.message === "Video created successfully" ||
        responseData?.success === true;

      if (!isSuccessful) {
        throw new Error(
          responseData?.message ||
            "The server could not start video generation."
        );
      }

      /*
       * Refresh account information only after the server
       * confirms that the generation request succeeded.
       */
      if (typeof setUserRefetch === "function") {
        setUserRefetch(!userRefetch);
      }

      await swal({
        title: "Request submitted successfully",
        text: `Your comic video is being generated. The video link will be sent to ${AIuser.email || "your registered email"}. Generation may take up to 10 minutes. You can continue using the platform while you wait.`,
        icon: "success",
        button: "Got it",
        className: "modal_class_success",
      });
    } catch (error) {
      console.error("Comic Video generation error:", error);

      await swal({
        title: "Video generation failed",
        text: getErrorMessage(
          error,
          "We could not submit your video request. Please try again."
        ),
        icon: "error",
        button: "Close",
        className: "modal_class_success",
      });
    } finally {
      generatingRef.current = false;

      if (mountedRef.current) {
        setIsLoading(false);
      }
    }
  };

  return (
    <Fragment>
      

      <SampleTextVideo
        videoModal={videoModal}
        setVideoModal={setVideoModal}
        indexValue={1}
      />

      <SampleVideoModal
        setModalShow={setModalShow}
        modalShow={modalShow}
        videoPosition={0}
      />

      <p
      style={{
        width: "400px",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        allignItems: "center",
      }}
      className="all-page-title all-page-gradient-text text-center my-4">
        COMIC VIDEO AI
      </p>

      <div className="container pb-5">
        {/* Credits and navigation actions */}
        <div className="credits-actions pt-4 pb-2">
          <button
            type="button"
            className="credits-button"
            aria-label={`Current credits: ${creditToLocalString}`}
          >
            CREDITS : {creditToLocalString}
          </button>

          <button
            type="button"
            className="buy-credits-button"
            onClick={() => navigate("/purchase")}
          >
            BUY CREDITS
          </button>

          <button
            type="button"
            className="money-exchange-button"
            onClick={() => navigate("/usage")}
            aria-label="View credit usage"
            title="Credit usage"
          >
            <img src={moneyExchangeIcon} alt="" />
          </button>

          <button
            type="button"
            className="money-exchange-button"
            onClick={() => setModalShow(true)}
            aria-label="Watch sample video"
            title="Watch sample video"
          >
            <img src={sampleIcon} alt="" />
          </button>
        </div>

        <p
        style={{ fontSize: "10px" }}
        className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm">
          <small>
            {credit.toLocaleString()} Credits per video (USD{" "}
            {creditCostUSD.toFixed(2)} based on Credits Package 3)
          </small>
        </p>

        {/* <p className="text-white text-center mt-3 mb-4">
          <small>
            Your video will be generated on our server and sent to your
            registered email, so you don't have to wait.
          </small>
        </p> */}

        <div className="container pt-3">
          <div className="comic-video-form">
            {/* Input mode */}
            {/* <div className="mb-3">
              <label
                htmlFor="comicVideoOwnScript"
                className="comic-video-own-script"
              >
                <input
                  type="checkbox"
                  id="comicVideoOwnScript"
                  checked={enableOwnScript}
                  onChange={handleOwnScriptChange}
                  disabled={isLoading}
                />

                <span>
                  Write my own script (maximum {MAX_SCRIPT_WORDS} words).
                  Leave unchecked to enter a title and receive an AI
                  suggestion.
                </span>
              </label>
            </div> */}

            <div className="text-center mb-3">
              <p className="text-white mb-2">
                {enableOwnScript
                  ? "Enter your own comic video script."
                  : "Enter the title of the comic video you want to generate."}
              </p>

              {!enableOwnScript && (
                <div className="d-flex flex-column align-items-center">
                  <p className="comic-video-example mb-2">
                    <span className="text-danger">Example:</span>{" "}
                    <button
                      type="button"
                      onClick={() =>
                        handleExampleSelect(randomQuestion)
                      }
                      disabled={isLoading}
                      className="btn btn-link text-warning p-0 border-0"
                      style={{
                        textDecoration: "none",
                        overflowWrap: "anywhere",
                      }}
                    >
                      {randomQuestion}
                    </button>
                  </p>

                  <button
                    type="button"
                    className="btn p-1 border-0"
                    onClick={handleRandomQuestion}
                    disabled={isLoading}
                    title="Generate another example"
                    aria-label="Generate another example"
                  >
                    <img
                      src={reload}
                      alt=""
                      width="28"
                      height="28"
                      style={{ objectFit: "contain" }}
                    />
                  </button>
                </div>
              )}
            </div>

            {/* Title / script input */}
            <div className="mb-3">
              <label
                htmlFor="comicVideoInput"
                className="text-white mb-2"
                style={{ fontSize: "14px" }}
              >
                {enableOwnScript ? "Your Script" : "Video Title"}{" "}
                <span className="text-danger">*</span>
              </label>

              <textarea
                id="comicVideoInput"
                className="comic-video-input"
                value={inputText}
                name="comicVideoInput"
                rows={enableOwnScript ? 8 : 4}
                maxLength={enableOwnScript ? undefined : 2000}
                placeholder={
                  enableOwnScript
                    ? "Write your comic video script here..."
                    : "Describe the topic of your comic video..."
                }
                onChange={handleTextChange}
                disabled={isLoading}
                aria-describedby="comicVideoWordCount"
              />

              <div
                id="comicVideoWordCount"
                className={`comic-video-word-count ${
                  exceedsWordLimit ? "is-over-limit" : ""
                }`}
              >
                {wordCount} / {MAX_SCRIPT_WORDS} words
                {enableOwnScript && !exceedsWordLimit
                  ? " — within limit"
                  : ""}
              </div>

              {exceedsWordLimit && (
                <p className="warning" role="alert">
                  Your script exceeds {MAX_SCRIPT_WORDS} words. Please
                  shorten it before generating your video.
                </p>
              )}
            </div>

            {/* Prompt suggestion loading state */}
            {checkingPrompt && !enableOwnScript && (
              <div
                className="comic-video-status"
                role="status"
                aria-live="polite"
              >
                <span
                  className="spinner-border spinner-border-sm"
                  aria-hidden="true"
                />
                <span>Generating suggestion...</span>
              </div>
            )}

            {/* Prompt suggestion error */}
            {promptError && !checkingPrompt && !enableOwnScript && (
              <div
                className="comic-video-status comic-video-status-error"
                role="status"
              >
                <span>{promptError}</span>
              </div>
            )}

            {/* Clickable suggested idea */}
            {suggestedIdea && !enableOwnScript && (
              <div
                className="comic-video-suggestion"
                role="button"
                tabIndex={0}
                onClick={handleSuggestionSelect}
                onKeyDown={(event) => {
                  if (
                    event.key === "Enter" ||
                    event.key === " "
                  ) {
                    event.preventDefault();
                    handleSuggestionSelect();
                  }
                }}
                aria-label="Use this suggested comic video idea"
              >
                <p className="mb-1 text-warning fw-semibold">
                  Suggested Comic Video Idea
                </p>

                <p className="mb-2 text-white">{suggestedIdea}</p>

                <span className="text-info">
                  Click to use this suggestion
                </span>
              </div>
            )}

            {/* Aspect ratio selection */}
            <div className="mb-4 mt-4">
              <label className="text-white mb-2 d-block">
                Aspect Ratio <span className="text-danger">*</span>
              </label>

              <div
                className="comic-video-ratio-grid"
                role="group"
                aria-label="Select video aspect ratio"
              >
                {aspectRatioOptions.map((option) => {
                  const selected = aspectRatio === option.value;

                  return (
                    <button
                      type="button"
                      key={option.value}
                      className={`comic-video-ratio-card ${
                        selected ? "selected" : ""
                      }`}
                      onClick={() => setAspectRatio(option.value)}
                      disabled={isLoading}
                      aria-pressed={selected}
                    >
                      <span className="ratio-value">
                        {option.label}
                      </span>

                      <span className="ratio-label">
                        {option.description}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Attribution */}
            <div className="d-flex align-items-center justify-content-center text-center mt-4">
              <input
                type="checkbox"
                id="attributionCheckboxInline"
                className="form-check-input mt-0 me-2"
                checked={attributionPage}
                onChange={(event) =>
                  setAttributionPage(event.target.checked)
                }
                disabled={isLoading}
              />

              <label
                htmlFor="attributionCheckboxInline"
                className="text-white"
                style={{
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                The Attribution
              </label>
            </div>

            {/* Content audit */}
            <div className="mt-4">
              <AiContentAudit
                checked={auditChecked}
                onChange={setAuditChecked}
                auditCreditCost={AUDIT_EXTRA_CREDITS}
              />
            </div>

            {/* Form actions */}
            <div className="comic-video-action-row mt-4">
              <button
                type="button"
                onClick={handleClear}
                className="clear-button"
                disabled={isLoading}
              >
                Clear
              </button>

              <button
                type="button"
                onClick={ConfirmVideo}
                className={
                  isGenerateButtonDisabled
                    ? "generate-buttonDisabled"
                    : "generate-button"
                }
                disabled={isGenerateButtonDisabled}
                aria-busy={isLoading}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      aria-hidden="true"
                    />
                    Submitting...
                  </>
                ) : (
                  "Generate Video"
                )}
              </button>
            </div>

            <p className="text-white text-center mt-4 mb-0">
              <small>
                AI can occasionally make mistakes. Please verify any
                important information.
              </small>
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ComicVideo;























// import { Fragment, useContext, useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "./video-ai.css";
// import axios from "axios";
// import { UserAuthContext } from "../../Contexts/UserAuthContext";
// import PageHeading from "../../Components/PageHeading/PageHeading";
// import swal from "sweetalert";
// import CreditsButton from "../../utils/CreditsButton";
// import reload from "../../Assets/Images/relaoder.png";
// import InfoIcon from "@mui/icons-material/Info";
// import { IconButton } from "@material-ui/core";
// import SampleVideoModal from "../../Components/VideoAi/SampleVideoModal";
// import SampleTextVideo from "../../Components/AIVideoSample/TextVideo";
// import AiContentAudit from "../../Components/AiContentAudit/AiContentAudit";
// import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
// import sampleIcon from "../../Assets/Images/info.png";


// const aspectRatioOptions = [
//   { value: "1:1", label: "1:1", description: "Square poster" },
//   { value: "9:16", label: "9:16", description: "Mobile / Story / TikTok" },
//   { value: "16:9", label: "16:9", description: "Wide cinematic poster" }
// ];

// const ComicVideo = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [randomQuestion, setRandomQuestion] = useState("");
//   const [modalShow, setModalShow] = useState(false);
//   const [attributionPage, setAttributionPage] = useState(true);
//   const [aspectRatio, setAspectRatio] = useState("");

//   const baseCredit = 500;


//   // Function to get a random question
//   const getRandomQuestion = () => {
//     const questions = [
//       "The Birth of the Solar System",
//       "How Dinosaurs Ruled the Earth",
//       "The Wonders of the Human Brain",
//       "How the Internet Works",
//       "The History of Space Exploration",
//       "Understanding Climate Change",
//       "The Mysteries of the Ocean",
//       "How Planes Stay in the Air",
//       "The Evolution of Life on Earth",
//       "How Volcanoes Erupt",
//       "The Science of Earthquakes",
//       "The Life Cycle of a Star",
//       "The Secrets of DNA",
//       "The History of Ancient Egypt",
//       "The Human Digestive System Explained",
//       "How Batteries Store Energy",
//       "The Journey of a Raindrop",
//       "The Physics of Roller Coasters",
//       "The World of Microbes",
//       "The History of the Roman Empire",
//       "The Function of the Human Heart",
//       "The Science Behind Vaccines",
//       "The Basics of Quantum Physics",
//       "How Plants Perform Photosynthesis",
//       "The History of the Olympic Games",
//       "How Electricity Powers Our World",
//       "The Science of Cooking",
//       "The Story of the Great Wall of China",
//       "How Computers Work",

//       "The Wonders of the Animal Kingdom",
//       "The History of the Renaissance",
//       "How Telescopes Work",
//       "The Life of a Honeybee",
//       "The Basics of the Human Immune System",
//       "The Science Behind Weather Forecasting",
//       "The Story of the Titanic",
//       "The Evolution of Human Languages",
//       "How the Moon Affects Earth",
//       "The History of the American Civil War",
//       "The Life Cycle of a Butterfly",
//       "The Science of Sound Waves",
//       "The History of the Printing Press",
//       "How Bridges Are Built",
//       "The Secrets of Coral Reefs",
//       "The History of the Space Race",
//       "The Basics of Human Genetics",
//       "The Science of Optical Illusions",
//       "The History of the Internet",
//       "How Engines Work",
//       "The Wonders of the Night Sky",
//       "The History of Ancient Greece",
//       "The Human Respiratory System Explained",
//       "The Science of Renewable Energy",
//       "The Story of the Pyramids",
//       "How Robots Work",
//       "The Basics of Chemical Reactions",
//       "The History of the French Revolution",
//       "The Science Behind Time Travel Theories",
//       "The World of Insects",
//       "The Evolution of Technology",
//       "How Submarines Work",
//       "The History of Medieval Europe",
//       "The Science of Sleep",
//       "The Wonders of the Amazon Rainforest",
//       "How Magnets Work",
//       "The History of the Industrial Revolution",
//       "The Science of Climate Zones",
//       "The Evolution of the Human Species",
//       "How Satellites Work",
//       "The History of the Cold War",
//       "The Human Circulatory System Explained",
//       "The Science of Germs and Hygiene",
//       "The History of Ancient Mesopotamia",
//       "How Skyscrapers Are Built",
//       "The Basics of Ecosystems",
//       "The Story of the Wright Brothers",
//       "How Solar Panels Work",
//       "The Science of Black Holes",
//       "The History of the Viking Age",
//       "The Human Skeletal System Explained",
//       "The Science of Natural Disasters",
//       "The History of the Space Shuttle",
//       "How Rockets Work",
//       "The Wonders of the Desert Biome",
//       "The Basics of Photosynthesis",
//       "The History of the British Empire",
//       "The Science Behind the Human Voice",
//       "The Evolution of Music",
//       "How Wind Turbines Work",
//       "The History of the American Revolution",
//       "The Human Nervous System Explained",
//       "The Science of Bacteria",
//       "The History of the World Wars",
//       "How 3D Printing Works",
//       "The Wonders of the Arctic Circle",
//       "The Basics of Animal Behavior",
//       "The Story of the Moon Landing",
//       "The Science Behind Holograms",
//       "The History of Ancient Rome",
//       "How Electric Cars Work",
//     ];

//     const randomIndex = Math.floor(Math.random() * questions.length);
//     return questions[randomIndex];
//   };

//   // Set random question when component mounts
//   useEffect(() => {
//     setRandomQuestion(getRandomQuestion());
//   }, []);

//   const [isGenerateButtonDisabled, setIsGenerateButtonDisabled] =
//     useState(false);

//   const { AIuser, userRefetch, setUserRefetch, isBack } =
//     useContext(UserAuthContext);

//   const [inputText, setInputText] = useState("");
//   const [enableOwnScript, setEnableOwnScript] = useState(false);
//   const [videoModal, setVideoModal] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [suggestedIdea, setSuggestedIdea] = useState("");
//   const [checkingPrompt, setCheckingPrompt] = useState(false);
//   const [auditChecked, setAuditChecked] = useState(false);
//   const credit = auditChecked ? baseCredit + 334 : baseCredit;
//   const creditCostUSD = auditChecked ? 6 + 4.01 : 6;
//   const videoPosition = 0;
//   const promptTimeoutRef = useRef(null);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     if (location?.state?.back && isBack) {
//       const backInput = location?.state?.inputText;
//       setInputText(backInput);
//     }
//     // const isBack = location?.state?.back;
//   }, [location, isBack]);

//   useEffect(() => {
//     if (location.state !== null) {
//       setInputText(location.state.requestQues);
//     }
//   }, [location.state]);

//   const checkComicIdeaPrompt = async (value) => {
//     if (!value?.trim()) {
//       setSuggestedIdea("");
//       return;
//     }

//     try {
//       setCheckingPrompt(true);

//       const authToken = localStorage.getItem("aiUser");

//       const res = await axios.post(
//         "https://backend.whalesai.com/api/v1/prompt-checker/check",
//         {
//           prompt: value,
//           aiService: "comic-video-ai",
//         },
//         {
//           headers: {
//             authorization: `Bearer ${authToken}`,
//           },
//         }
//       );

//       if (res?.data?.success) {
//         setSuggestedIdea(res.data.data.suggested_prompt);
//       }
//     } catch (error) {
//       console.log("Prompt checker error:", error);
//     } finally {
//       setCheckingPrompt(false);
//     }
//   };

//   const ConfirmVideo = async () => {
//     if (isGenerateButtonDisabled) return;

//     if (AIuser.credits > credit) {
//       // Show the popup after a short delay (1 second)
//       setTimeout(() => {
//         const wrapper = document.createElement("div");
//         wrapper.innerHTML = `<p></p> <p class="text-white">We are generating the video for you. We will send the video link to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

//         swal({
//           content: wrapper,
//           icon: "success",
//           button: "Close",
//           className: "modal_class_success",
//         }).then(() => {
//           // Update the button text to "Refreshing the page for you"
//           swal({
//             icon: "success",
//             button: {
//               text: "Refreshing the page for you",
//               className: "bg-danger",
//             },
//             confirmButtonClass: "bg-danger",
//             className: "modal_class_success",
//             closeOnClickOutside: false, // Prevent closing by clicking outside
//           });

//           // Reload the page after a short delay to allow the user to see the updated text
//           setTimeout(() => {
//             window.location.reload();
//           }, 1000); // Adjust the delay as needed
//         });
//       }, 1000);

//       setIsLoading(true);
//       // handleSubmitCredits();
//       setUserRefetch(!userRefetch)

//       const bodyContent = {
//         title: inputText,
//         email: AIuser?.email,
//         aspectRatio,
//         attributionPage,
//         credit,
//         audit: auditChecked
//       };

//       try {
//         const response = await fetch(
//           `https://backend.whalesai.com/api/v1/comic-video-ai/generate`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               authorization: `Bearer ${localStorage.getItem("aiUser")}`,
//             },
//             body: JSON.stringify(bodyContent),
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Failed to generate video");
//         }

//         const data = await response.json();
//         if (data.message === "Video created successfully") {
//           alert("video created successfully");

//           setIsLoading(false);
//         } else {
//           throw new Error("Failed to generate video");
//         }
//       } catch (error) {
//         console.error("Error generating video:", error);
//         setIsLoading(false);
//       }
//     } else {
//       swal({
//         text: "You don't have enough credits! Please buy credits to continue.",

//         icon: "error",
//         buttons: "Buy",
//         className: "modal_class_success",
//       }).then((value) => {
//         if (value) {
//           navigate("/purchase");
//         }
//       });
//     }
//   };

//   const handleTextChange = (e) => {
//     const text = e.target.value;
//     const wordCount = text.split(/\s+/).length;
//     setInputText(text);

//     if (enableOwnScript && wordCount > 600) {
//       setIsGenerateButtonDisabled(true);
//     } else {
//       setIsGenerateButtonDisabled(false);
//     }

//     if (promptTimeoutRef.current) {
//       clearTimeout(promptTimeoutRef.current);
//     }

//     promptTimeoutRef.current = setTimeout(() => {
//       checkComicIdeaPrompt(text);
//     }, 1500);
//   };

//   const handleTrigger = () => {
//     setInputText("");
//     setEnableOwnScript(false);
//   };

//   const creditToLocalString = AIuser?.credits ? parseInt(Math.floor(AIuser?.credits)).toLocaleString() : "0";

//   return (

//     <>
//     <Fragment>
//       <p className="all-page-title all-page-gradient-text text-center my-4">COMIC VIDEO AI</p>
//       {/* <PageHeading
//         title="Comic Video AI"
//         description="The Comic Video AI is capable of creating narrated comic videos."
//         onInfoClick={() => setVideoModal(true)}
//         infoTooltip="See sample video"
//       /> */}

//       <SampleTextVideo
//         videoModal={videoModal}
//         setVideoModal={setVideoModal}
//         indexValue={1}
//       />

//       <SampleVideoModal
//         setModalShow={setModalShow}
//         modalShow={modalShow}
//         videoPosition={videoPosition}
//       />
      
//       <div className="container pb-5">
//         {/* <div
//           style={{
//             maxWidth: "872px",
//             paddingInline: "12px",
//             marginInline: "auto",
//           }}
//         >
//           <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm">
//             <div className="d-flex ">
//               <CreditsButton />
//             </div>
//           </div>
//           <p
//             style={{ fontSize: "8px" }}
//             className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm"
//           >
//             {credit} Credits per video (USD {creditCostUSD.toFixed(2)} based on Credits Package 3)
//           </p>
//         </div> */}

        

//         <div className="credits-actions pt-4 pb-2">
//           <button className="credits-button">
//             CREDITS : {creditToLocalString}
//           </button>

//           <button
//             className="buy-credits-button"
//             onClick={() => navigate("/purchase")}
//           >
//             BUY CREDITS
//           </button>

//           <button
//             onClick={() => navigate("/usage")}
//             className="money-exchange-button"
//           >
//             <img src={moneyExchangeIcon} alt="usage" />
//           </button>

//           <button
//             type="button"
//             className="money-exchange-button"
//             onClick={() => {
//               setModalShow(true);
//             }}

//           >
//             <img src={sampleIcon} alt="See sample video" />
//           </button>

//         </div>

//         <p
//           style={{ fontSize: "8px" }}
//           className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm"
//         >
//           {credit} Credits per video (USD {creditCostUSD.toFixed(2)} based on Credits Package 3)
//         </p>


//         <p style={{ fontSize: "10px" }} className="text-white text-md-center text-lg-center text-center mb-5 d-flex justify-content-center">This AI will be generated on our server and sent to your email, so you don't have to wait</p>

//         <div className="container pt-3">
//           <div style={{ maxWidth: "850px" }} className="mx-auto">
//             <div className="d-flex align-items-center justify-content-center">
//               <p className="text-white centralize-credits-btn-sm text-center">
//                 {`${enableOwnScript ? "Enter your own script (max 600 words)." : "Enter Title of Comic Video you want to generate."}`}
//               </p>
//             </div>
//             {!enableOwnScript && (
//               <div
//                 style={{ flexDirection: "column" }}
//                 className="d-flex align-items-center text-center text-sm-start"
//               >
//                 <p
//                   onClick={() => {
//                     setInputText(randomQuestion);
//                     if (promptTimeoutRef.current) {
//                       clearTimeout(promptTimeoutRef.current);
//                     }
//                     promptTimeoutRef.current = setTimeout(() => {
//                       checkComicIdeaPrompt(randomQuestion);
//                     }, 1500);
//                   }}
//                   style={{ cursor: "pointer" }}
//                   className="text-warning my-2 text-center"
//                 >
//                   <span className="text-danger">Example:</span> {randomQuestion}
//                 </p>
//                 <img
//                   onClick={() => setRandomQuestion(getRandomQuestion())}
//                   style={{ cursor: "pointer" }}
//                   src={reload}
//                   alt="reload"
//                   width="30"
//                   height="30"
//                   className="my-2"
//                 />
//               </div>
//             )}
//             <div className="mb-4">
//               <label className="text-white mb-2" style={{ fontSize: "14px" }}>
//                 Title  <span className="text-danger">*</span>
//               </label>
//               <textarea
//                 className="p-2 px-3 w-100 text-white"
//                 style={{
//                   background: "#011C34",
//                   border: "2px solid #FFF",
//                   borderRadius: "12px",
//                   outline: "none",
//                   height: "120px",
//                 }}
//                 id="inputText"
//                 type="text"
//                 lang="en"
//                 value={inputText}
//                 name="inputBox"
//                 rows={enableOwnScript ? 8 : 4}
//                 onChange={handleTextChange}
//               />
//             </div>

//             {inputText?.split(/\s+/).length > 600 && (
//               <div
//                 style={{ cursor: "pointer" }}
//                 onClick={() => handleTrigger()}
//                 className="warning "
//               >
//                 Warning: Your text exceeds 600 words. Please edit it to 600
//                 words or let the AI generate a shortened version for you.
//               </div>
//             )}

//             {checkingPrompt && (
//               <div className="d-flex align-items-center mt-2 mb-2">
//                 <div className="spinner-border text-light spinner-border-sm me-2" role="status">
//                   <span className="visually-hidden">Loading...</span>
//                 </div>
//                 <span className="text-warning" style={{ marginLeft: "8px" }}>Generating suggestion...</span>
//               </div>
//             )}

//             {suggestedIdea && (
//               <div
//                 onClick={() => setInputText(suggestedIdea)}
//                 style={{
//                   cursor: "pointer",
//                   background: "#0b2d4d",
//                   padding: "12px",
//                   borderRadius: "10px",
//                   marginTop: "10px",
//                   marginBottom: "12px",
//                   border: "1px solid #fff",
//                 }}
//               >
//                 <p className="mb-1 text-warning">Suggested Comic Video Idea:</p>
//                 <p className="mb-0 text-white">{suggestedIdea}</p>
//               </div>
//             )}

//             <div className="mb-4">
//               <label className="text-white mb-2" style={{ fontSize: "14px" }}>
//                 Aspect Ratio <span className="text-danger">*</span>
//               </label>
//               <div className="comic-video-ratio-grid">
//                 {aspectRatioOptions.map((option) => (
//                   <div
//                     key={option.value}
//                     className={`comic-video-ratio-card ${aspectRatio === option.value ? "selected" : ""}`}
//                     onClick={() => setAspectRatio(option.value)}
//                   >
//                     <div className="ratio-value">{option.label}</div>
//                     <div className="ratio-label">{option.description}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div
//               className="d-flex align-items-center justify-content-center text-center mt-4"
//             >
//               <input
//                 type="checkbox"
//                 id="attributionCheckboxInline"
//                 style={{ marginRight: '8px' }}
//                 checked={attributionPage}
//                 onChange={(e) => setAttributionPage(e.target.checked)}
//               />
//               <label htmlFor="attributionCheckboxInline" className="text-white" style={{ fontSize: '14px', cursor: 'pointer' }}>
//                 The Attribution
//               </label>
//             </div>

//             <AiContentAudit checked={auditChecked} onChange={setAuditChecked} auditCreditCost={334} />

//             <div className="mt-4 text-center">
//               <button
//                 onClick={() => {
//                   setInputText("");
//                   setAspectRatio("")
//                   setIsGenerateButtonDisabled(false);
//                   setSuggestedIdea("");
//                 }}
//                 className="clear-button rounded"
//               >
//                 Clear
//               </button>

//               <button
//                 onClick={ConfirmVideo}
//                 className={`generate-button rounded ${!inputText || !aspectRatio ? "bg-secondary" : ""}`}
//                 disabled={!inputText || !aspectRatio || isLoading}
//               >
//                 Generate
//               </button>
//             </div>
//             <p className="mt-3"></p>
//             <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
//               While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
//             </div>

//             <div className="btnvideoDiv"></div>
//           </div>
//         </div>
//       </div>
//     </Fragment>
//     </>
//   );
// };

// export default ComicVideo;
